import RoleVariable from "../model/RoleVariable";
import m from "./module";

const path = "/role_variable";
const type = "RoleVariable";

class RoleVariableService {
  constructor($q, LogService, DataSyncService) {
    "ngInject";
    this.$q = $q;
    this.LogService = LogService;
    this.DataSyncService = DataSyncService;
  }

  create(data) {
    return this.createIsolated(data).then((roleVariable) => {
      if (roleVariable.id) {
        return this.DataSyncService.setObjectById(
          type,
          roleVariable.id,
          roleVariable
        );
      } else {
        return roleVariable;
      }
    });
  }

  createIsolated(data) {
    return this.$q.when(new RoleVariable(data));
  }

  createOriginals(data) {
    return this.createIsolatedOriginal(data).then((roleVariable) => {
      if (roleVariable.id) {
        return this.DataSyncService.setObjectById(
          type,
          roleVariable.id,
          roleVariable
        );
      } else {
        return roleVariable;
      }
    });
  }

  createIsolatedOriginal(data) {
    // We're getting back roles and their IDs, which correspond to `role_variables_id`s in the database.
    // Map the role ID to that value so everything works properly elsewhere
    data.role_variables_id = data.id;
    delete data.id;
    return this.$q.when(new RoleVariable(data));
  }

  getAll(config = null) {
    return this.DataSyncService.getMultipleObjects(
      type,
      path,
      (data) => this.create(data),
      config
    ).then((data) =>
      data.map((rv) => ({ role_variables_id: rv.id, name: rv.name }))
    );
  }

  serialize(roleVariable) {
    return {
      id: roleVariable.id,
      role_variables_id: roleVariable.role_variables_id,
      events_custom_instances_id: roleVariable.events_custom_instances_id,
      events_custom_field_blocks_id: roleVariable.events_custom_field_blocks_id,
      events_custom_forms_id: roleVariable.events_custom_forms_id,
      events_custom_forms_products_id: roleVariable.events_custom_forms_products_id,
    };
  }
}

export default RoleVariableService;

m.service("RoleVariableService", RoleVariableService);
